/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Sign_OutInputs */

const en_invite_x15_sign_out = /** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out and use another account`)
};

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const ar_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const he_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const ur_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const es_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const fr_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const de_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const pt_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const hi_invite_x15_sign_out = en_invite_x15_sign_out;

/** @type {(inputs: Invite_X15_Sign_OutInputs) => LocalizedString} */
const bn_invite_x15_sign_out = en_invite_x15_sign_out;

/**
* | output |
* | --- |
* | "Sign out and use another account" |
*
* @param {Invite_X15_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_sign_out = /** @type {((inputs?: Invite_X15_Sign_OutInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Sign_OutInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_sign_out(inputs)
	if (locale === "he") return he_invite_x15_sign_out(inputs)
	if (locale === "ur") return ur_invite_x15_sign_out(inputs)
	if (locale === "es") return es_invite_x15_sign_out(inputs)
	if (locale === "fr") return fr_invite_x15_sign_out(inputs)
	if (locale === "de") return de_invite_x15_sign_out(inputs)
	if (locale === "pt") return pt_invite_x15_sign_out(inputs)
	if (locale === "hi") return hi_invite_x15_sign_out(inputs)
	if (locale === "bn") return bn_invite_x15_sign_out(inputs)
	return /** @type {LocalizedString} */ ("Sign out and use another account")
});